export function normalizeQueryResult(payload) {
  if (!payload) {
    return { visualization: 'table', result: { kind: 'table', columns: [], rows: [] } };
  }
  return {
    spec: payload.spec || {},
    visualization: payload.visualization || 'table',
    result: payload.result || { kind: 'table', columns: [], rows: [] },
    rowCount: payload.row_count ?? 0,
  };
}

export default normalizeQueryResult;
